import { Box } from '@mui/system';
import styled from 'styled-components';

export const TableHolder = styled(Box)(({ theme }) => ({
  flex: 1,
  width: '100%',
  backgroundColor: theme.palette.base.background,
  overflow: 'hidden',
  height: '692px',
  borderRadius: '8px',
  '.MuiDataGrid-iconSeparator': {
    display: 'none',
  },
  '.MuiDataGrid-menuIconButton': {
    display: 'none',
  },
  '.MuiDataGrid-virtualScroller': {
    overflowX: 'hidden',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
  '.MuiDataGrid-cell': {
    border: 'none',
    padding: '0 24px',
  },
  '.MuiDataGrid-row:nth-child(odd)': {
    backgroundColor: theme.palette.grey[50],
  },
  '.MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '.MuiDataGrid-columnHeaders': {
    border: 'none',
  },
  '.MuiDataGrid-columnHeader:focus': {
    outline: 'none',
  },
  '.MuiDataGrid-columnHeaderTitleContainer': {
    padding: '0 12px',
  },
}));
